// Google Maps API Configuration
// Using the new Firebase project API key. Enable Maps APIs on swatin-courier.

export const GoogleMapApiConfig = "AIzaSyBVFQYvKGY-WEo5rI-KXkQ1ysXdwauE_AE";

export default GoogleMapApiConfig;
